"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[7828],{

/***/ 51971:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ PatientContext),
/* harmony export */   "p": () => (/* binding */ usePatientContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);

const PatientContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(
  null
);
const usePatientContext = () => react__WEBPACK_IMPORTED_MODULE_0__.useContext(PatientContext);


/***/ }),

/***/ 20058:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11313);


const FormattedDate = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_1__/* .FormattedDate */ .Ji, {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  ...props
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FormattedDate);


/***/ }),

/***/ 13873:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A7": () => (/* binding */ useEmitErrorNotification),
/* harmony export */   "hy": () => (/* binding */ useEmitNotification),
/* harmony export */   "tc": () => (/* binding */ useEmitSuccessNotification)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28841);
/* harmony import */ var _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_1__);


function mapOptionsToToastOptions(options) {
  return {
    duration: (options == null ? void 0 : options.forceUserToClose) ? Infinity : options == null ? void 0 : options.autoHideDuration
  };
}
function useEmitSuccessNotification() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((message, options) => {
    _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_1___default().success(message, mapOptionsToToastOptions(options));
  }, []);
}
function useEmitErrorNotification() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((message, options) => {
    _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_1___default().error(message, mapOptionsToToastOptions(options));
  }, []);
}
function useEmitNotification() {
  const emitSuccessNotification = useEmitSuccessNotification();
  const emitErrorNotification = useEmitErrorNotification();
  return {
    emitSuccessNotification,
    emitErrorNotification
  };
}


/***/ }),

/***/ 58859:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ai": () => (/* binding */ GetFacilityQueuesDocument),
/* harmony export */   "rb": () => (/* binding */ QueuePatientFragmentFragmentDoc),
/* harmony export */   "z5": () => (/* binding */ useGetFacilityQueuesQuery)
/* harmony export */ });
/* unused harmony exports GetClinicDocument, useGetClinicQuery, useGetClinicLazyQuery, CreatePatientQueueDocument, useCreatePatientQueueMutation, useGetFacilityQueuesLazyQuery, GetPatientQueueDocument, useGetPatientQueueQuery, useGetPatientQueueLazyQuery, DeletePatientQueueDocument, useDeletePatientQueueMutation */
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24520);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41552);


const defaultOptions = {};
const QueuePatientFragmentFragmentDoc = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    fragment QueuePatientFragment on PatientOfQueue {
  uuid
  fullname
  gender
  addedAt
  triageStatus {
    _id
    currentStatus
    expiresAt
    createdAt
    updatedAt
  }
}
    `;
const GetClinicDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    query getClinic($id: String!) {
  clinic(id: $id) {
    uuid
    name
  }
}
    `;
function useGetClinicQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(GetClinicDocument, options);
}
function useGetClinicLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(GetClinicDocument, options);
}
const CreatePatientQueueDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    mutation CreatePatientQueue($input: CreatePatientQueueInput!) {
  createPatientQueue(input: $input) {
    _id
    name
    patients {
      ...QueuePatientFragment
    }
  }
}
    ${QueuePatientFragmentFragmentDoc}`;
function useCreatePatientQueueMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation(CreatePatientQueueDocument, options);
}
const GetFacilityQueuesDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    query getFacilityQueues {
  facilityQueues {
    _id
    name
    patients {
      ...QueuePatientFragment
    }
  }
}
    ${QueuePatientFragmentFragmentDoc}`;
function useGetFacilityQueuesQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a(GetFacilityQueuesDocument, options);
}
function useGetFacilityQueuesLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(GetFacilityQueuesDocument, options);
}
const GetPatientQueueDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    query getPatientQueue($input: FacilityQueueInput!) {
  facilityQueue(input: $input) {
    _id
    name
    patients {
      ...QueuePatientFragment
    }
  }
}
    ${QueuePatientFragmentFragmentDoc}`;
function useGetPatientQueueQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(GetPatientQueueDocument, options);
}
function useGetPatientQueueLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(GetPatientQueueDocument, options);
}
const DeletePatientQueueDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
    mutation DeletePatientQueue($input: DeletePatientQueueInput!) {
  deletePatientQueue(input: $input) {
    _id
    deletionSuccess
    message
  }
}
    `;
function useDeletePatientQueueMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation(DeletePatientQueueDocument, options);
}


/***/ }),

/***/ 27047:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JT": () => (/* binding */ FACILITY_QUEUES),
/* harmony export */   "Jy": () => (/* binding */ QUEUE_PATIENT_FRAGMENT),
/* harmony export */   "Ow": () => (/* binding */ CREATE_QUEUE),
/* harmony export */   "U0": () => (/* binding */ DELETE_QUEUE)
/* harmony export */ });
/* unused harmony exports CLINIC_QUERY, FACILITY_QUEUE */
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24520);

const QUEUE_PATIENT_FRAGMENT = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
  fragment QueuePatientFragment on PatientOfQueue {
    uuid
    fullname
    gender
    addedAt
    triageStatus {
      _id
      currentStatus
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
const CLINIC_QUERY = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
  query getClinic($id: String!) {
    clinic(id: $id) {
      uuid
      name
    }
  }
`;
const CREATE_QUEUE = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
  ${QUEUE_PATIENT_FRAGMENT}

  mutation CreatePatientQueue($input: CreatePatientQueueInput!) {
    createPatientQueue(input: $input) {
      _id
      name
      # We must also query for the patients array, even though it will be empty,
      # as we are merging the result of this mutation with the cache
      patients {
        ...QueuePatientFragment
      }
    }
  }
`;
const FACILITY_QUEUES = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
  ${QUEUE_PATIENT_FRAGMENT}

  query getFacilityQueues {
    facilityQueues {
      _id
      name
      patients {
        ...QueuePatientFragment
      }
    }
  }
`;
const FACILITY_QUEUE = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
  ${QUEUE_PATIENT_FRAGMENT}

  query getPatientQueue($input: FacilityQueueInput!) {
    facilityQueue(input: $input) {
      _id
      name
      patients {
        ...QueuePatientFragment
      }
    }
  }
`;
const DELETE_QUEUE = _apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps`
  mutation DeletePatientQueue($input: DeletePatientQueueInput!) {
    deletePatientQueue(input: $input) {
      _id
      deletionSuccess
      message
    }
  }
`;


/***/ }),

/***/ 882:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ patient_queue_QueueDropdown)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.2.6/node_modules/classnames/index.js
var classnames = __webpack_require__(97754);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(11313);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(77589);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(40374);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(64432);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/ArrowForward.js
var ArrowForward = __webpack_require__(62578);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-input@0.3.5_atek3e5pugfjeukz7kzynbm6iy/node_modules/@elephant-healthcare/mui-input/dist/module.js
var dist_module = __webpack_require__(34948);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var mui_icon_dist_module = __webpack_require__(46828);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var mui_style_dist_module = __webpack_require__(10353);
// EXTERNAL MODULE: ./src/client/routes/history/LocationHistoryProvider.tsx
var LocationHistoryProvider = __webpack_require__(58264);
// EXTERNAL MODULE: ./src/client/clinician/links.tsx
var links = __webpack_require__(65460);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var graphql_tag_lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(79226);
// EXTERNAL MODULE: ./src/client/apollo/RetryApolloContext.tsx
var RetryApolloContext = __webpack_require__(92560);
// EXTERNAL MODULE: ./src/client/components/Notification/useEmitNotification.tsx
var useEmitNotification = __webpack_require__(13873);
// EXTERNAL MODULE: ./src/client/patient-queue-management/queries.ts
var queries = __webpack_require__(27047);
// EXTERNAL MODULE: ./src/client/patient-queue-management/__generated__/queries.gql.ts
var queries_gql = __webpack_require__(58859);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
;// CONCATENATED MODULE: ./src/client/patient-queue/__generated__/graphql.gql.ts



const defaultOptions = {};
const PatientQueueFragmentFragmentDoc = graphql_tag_lib/* gql */.Ps`
    fragment PatientQueueFragment on PatientQueue {
  _id
  name
}
    `;
const PatientQueueWithPatientsFragmentFragmentDoc = graphql_tag_lib/* gql */.Ps`
    fragment PatientQueueWithPatientsFragment on PatientQueue {
  _id
  name
  patients {
    ...QueuePatientFragment
  }
}
    ${queries_gql/* QueuePatientFragmentFragmentDoc */.rb}`;
const QueryForPatientDocument = graphql_tag_lib/* gql */.Ps`
    query QueryForPatient($patientUuid: ID!) {
  queueForPatient(input: {patientUuid: $patientUuid}) {
    _id
  }
}
    `;
function useQueryForPatientQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(QueryForPatientDocument, options);
}
function useQueryForPatientLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(QueryForPatientDocument, options);
}
const PatientQueueDropdownDocument = graphql_tag_lib/* gql */.Ps`
    query PatientQueueDropdown($patientUuid: ID!) {
  facilityQueues {
    ...PatientQueueFragment
  }
  queueForPatient(input: {patientUuid: $patientUuid}) {
    _id
  }
}
    ${PatientQueueFragmentFragmentDoc}`;
function usePatientQueueDropdownQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(PatientQueueDropdownDocument, options);
}
function usePatientQueueDropdownLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(PatientQueueDropdownDocument, options);
}
const AddQueuePatientDocument = graphql_tag_lib/* gql */.Ps`
    mutation AddQueuePatient($input: AddQueuePatientInput!) {
  addQueuePatient(input: $input) {
    ...PatientQueueWithPatientsFragment
  }
}
    ${PatientQueueWithPatientsFragmentFragmentDoc}`;
function useAddQueuePatientMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(AddQueuePatientDocument, options);
}
const RemoveQueuePatientDocument = graphql_tag_lib/* gql */.Ps`
    mutation RemoveQueuePatient($input: RemoveQueuePatientInput!) {
  removeQueuePatient(input: $input) {
    ...PatientQueueWithPatientsFragment
  }
}
    ${PatientQueueWithPatientsFragmentFragmentDoc}`;
function useRemoveQueuePatientMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(RemoveQueuePatientDocument, options);
}
const MoveQueuePatientDocument = graphql_tag_lib/* gql */.Ps`
    mutation MoveQueuePatient($input: MoveQueuePatientInput!) {
  moveQueuePatient(input: $input) {
    ...PatientQueueWithPatientsFragment
  }
}
    ${PatientQueueWithPatientsFragmentFragmentDoc}`;
function useMoveQueuePatientMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(MoveQueuePatientDocument, options);
}

;// CONCATENATED MODULE: ./src/client/patient-queue/graphql.ts








const PATIENT_QUEUE_FRAGMENT = graphql_tag_lib/* gql */.Ps`
  fragment PatientQueueFragment on PatientQueue {
    _id
    name
  }
`;
const PATIENT_QUEUE_WITH_PATIENTS_FRAGMENT = graphql_tag_lib/* gql */.Ps`
  ${queries/* QUEUE_PATIENT_FRAGMENT */.Jy}

  fragment PatientQueueWithPatientsFragment on PatientQueue {
    _id
    name
    patients {
      ...QueuePatientFragment
    }
  }
`;
graphql_tag_lib/* gql */.Ps`
  query QueryForPatient($patientUuid: ID!) {
    queueForPatient(input: { patientUuid: $patientUuid }) {
      _id
    }
  }
`;
graphql_tag_lib/* gql */.Ps`
  ${PATIENT_QUEUE_FRAGMENT}

  query PatientQueueDropdown($patientUuid: ID!) {
    facilityQueues {
      ...PatientQueueFragment
    }

    queueForPatient(input: { patientUuid: $patientUuid }) {
      _id
    }
  }
`;
function useQueueDropdownQuery(patientUuid) {
  const retryClient = (0,RetryApolloContext/* useRetryApolloClient */.M)();
  const emitErrorNotification = (0,useEmitNotification/* useEmitErrorNotification */.A7)();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return usePatientQueueDropdownQuery({
    variables: { patientUuid },
    skip: !patientUuid,
    client: retryClient,
    onError() {
      emitErrorNotification(
        formatMessage({
          id: "patientQueueing.dropdown.fetch.error",
          defaultMessage: "Failed to fetch queues for facility"
        })
      );
    }
  });
}
graphql_tag_lib/* gql */.Ps`
  ${PATIENT_QUEUE_WITH_PATIENTS_FRAGMENT}

  mutation AddQueuePatient($input: AddQueuePatientInput!) {
    addQueuePatient(input: $input) {
      ...PatientQueueWithPatientsFragment
    }
  }
`;
graphql_tag_lib/* gql */.Ps`
  ${PATIENT_QUEUE_WITH_PATIENTS_FRAGMENT}

  mutation RemoveQueuePatient($input: RemoveQueuePatientInput!) {
    removeQueuePatient(input: $input) {
      ...PatientQueueWithPatientsFragment
    }
  }
`;
graphql_tag_lib/* gql */.Ps`
  ${PATIENT_QUEUE_WITH_PATIENTS_FRAGMENT}

  mutation MoveQueuePatient($input: MoveQueuePatientInput!) {
    moveQueuePatient(input: $input) {
      ...PatientQueueWithPatientsFragment
    }
  }
`;
function useUpdateCurrentQueue(patientUuid) {
  const apolloClient = (0,useApolloClient/* useApolloClient */.x)();
  return (newQueue) => {
    const currentQueueResult = apolloClient.cache.readQuery({
      query: QueryForPatientDocument,
      variables: { patientUuid }
    });
    apolloClient.cache.writeQuery({
      query: QueryForPatientDocument,
      variables: { patientUuid },
      data: { queueForPatient: newQueue }
    });
    const existingQueues = apolloClient.cache.readQuery(
      {
        query: queries_gql/* GetFacilityQueuesDocument */.Ai
      }
    );
    if (!existingQueues) {
      return;
    }
    const oldQueue = currentQueueResult == null ? void 0 : currentQueueResult.queueForPatient;
    if (!oldQueue)
      return;
    const nextQueues = existingQueues.facilityQueues.map((queue) => {
      if (oldQueue._id === queue._id) {
        return {
          ...queue,
          patients: queue.patients.filter(
            (patient) => patient.uuid !== patientUuid
          )
        };
      }
      return queue;
    });
    apolloClient.cache.writeQuery({
      query: queries_gql/* GetFacilityQueuesDocument */.Ai,
      data: { facilityQueues: nextQueues }
    });
  };
}
function useAddPatientToQueue(patientUuid, currentQueueId) {
  const emitSuccessNotification = (0,useEmitNotification/* useEmitSuccessNotification */.tc)();
  const emitErrorNotification = (0,useEmitNotification/* useEmitErrorNotification */.A7)();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const updateCurrentQueue = useUpdateCurrentQueue(patientUuid);
  const [addQueuePatient, addQueuePatientResult] = useAddQueuePatientMutation({
    onCompleted(data) {
      updateCurrentQueue(data.addQueuePatient);
      emitSuccessNotification(
        formatMessage({
          id: "patientQueueing.dropdown.mutation.add.success",
          defaultMessage: "Added patient to queue"
        })
      );
    },
    onError() {
      emitErrorNotification(
        formatMessage({
          id: "patientQueueing.dropdown.mutation.add.error",
          defaultMessage: "Failed to add patient to queue"
        })
      );
    }
  });
  const [moveQueuePatient, moveQueuePatientResult] = useMoveQueuePatientMutation({
    onCompleted(data) {
      updateCurrentQueue(data.moveQueuePatient);
      emitSuccessNotification(
        formatMessage({
          id: "patientQueueing.dropdown.mutation.move.success",
          defaultMessage: "Moved patient to new queue"
        })
      );
    },
    onError() {
      emitErrorNotification(
        formatMessage({
          id: "patientQueueing.dropdown.mutation.move.error",
          defaultMessage: "Failed to move patient to new queue"
        })
      );
    }
  });
  const isMove = !!currentQueueId;
  const handler = (0,react.useCallback)(
    async (nextQueueId) => {
      if (isMove) {
        await moveQueuePatient({
          variables: {
            input: { patientUuid, newQueueId: nextQueueId }
          }
        });
      } else {
        await addQueuePatient({
          variables: {
            input: { patientUuid, queueId: nextQueueId }
          }
        });
      }
    },
    [addQueuePatient, moveQueuePatient, patientUuid, isMove]
  );
  const result = isMove ? moveQueuePatientResult : addQueuePatientResult;
  return [
    handler,
    result,
    addQueuePatientResult,
    moveQueuePatientResult
  ];
}
function useRemovePatientFromQueue(patientUuid) {
  const emitSuccessNotification = (0,useEmitNotification/* useEmitSuccessNotification */.tc)();
  const emitErrorNotification = (0,useEmitNotification/* useEmitErrorNotification */.A7)();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const updateCurrentQueue = useUpdateCurrentQueue(patientUuid);
  const [removeQueuePatient, removeQueuePatientResult] = useRemoveQueuePatientMutation({
    onCompleted() {
      updateCurrentQueue(null);
      emitSuccessNotification(
        formatMessage({
          id: "patientQueueing.dropdown.mutation.remove.success",
          defaultMessage: "Removed patient from queue"
        })
      );
    },
    onError() {
      emitErrorNotification(
        formatMessage({
          id: "patientQueueing.dropdown.mutation.remove.error",
          defaultMessage: "Failed to remove patient from queue"
        })
      );
    }
  });
  const handler = (0,react.useCallback)(async () => {
    await removeQueuePatient({
      variables: {
        input: { patientUuid }
      }
    });
  }, [removeQueuePatient, patientUuid]);
  return [handler, removeQueuePatientResult];
}

// EXTERNAL MODULE: ./src/client/common/PatientProvider.ts
var PatientProvider = __webpack_require__(51971);
// EXTERNAL MODULE: ./src/client/routes/NavigateHome.tsx
var NavigateHome = __webpack_require__(55558);
;// CONCATENATED MODULE: ./src/client/patient-queue/QueueDropdown.tsx














const useStyles = (0,mui_style_dist_module/* makeStyles */.Z)((theme) => ({
  currentQueueOption: {
    color: theme.palette.grey[600],
    pointerEvents: "none",
    "&:hover": {
      backgroundColor: "inherit"
    }
  },
  container: {
    minWidth: 320
  },
  disabled: {
    color: theme.palette.grey[300],
    backgroundColor: "rgba(0, 0, 0, 0.12)"
  },
  actionContainer: {
    height: "44px",
    marginLeft: theme.spacing(1),
    minWidth: "44px",
    width: "44px"
  },
  selectFieldInput: {
    height: "52px"
  },
  forwardBtn: {
    backgroundColor: theme.palette.tertiary.main,
    "&:hover": {
      backgroundColor: theme.palette.tertiary.light
    },
    "&:focus": {
      backgroundColor: theme.palette.tertiary.light
    },
    "&:active": {
      backgroundColor: theme.palette.tertiary.dark
    }
  },
  option: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column"
  },
  removeOption: {
    borderTop: `1px solid ${theme.palette.grey.field}`,
    color: theme.palette.error.main
  },
  progressCircle: {
    height: "50%",
    outline: "none"
  },
  selectIcon: {
    color: theme.palette.secondary.main
  },
  updatedIcon: {
    alignItems: "center",
    backgroundColor: theme.palette.success.main,
    borderRadius: "50%",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    width: "100%"
  },
  warningIcon: {
    color: theme.palette.error.main
  }
}));
const ActionArea = ({
  dropdownUnavailable,
  loading,
  updating,
  updated,
  onUpdate,
  value
}) => {
  const classes = useStyles();
  if (loading) {
    return /* @__PURE__ */ react.createElement(CircularProgress/* default */.Z, {
      size: 21,
      color: "secondary",
      className: classes.progressCircle
    });
  }
  if (dropdownUnavailable) {
    return /* @__PURE__ */ react.createElement(mui_icon_dist_module.WarningIcon, {
      viewBox: "0 0 32 32",
      fontSize: "large",
      className: classes.warningIcon
    });
  }
  if (updated) {
    return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
      className: classnames_default()(classes.updatedIcon)
    }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.TickIcon, {
      "data-testid": "queue-dropdown-confirmation-icon"
    }));
  }
  return /* @__PURE__ */ react.createElement(IconButton/* default */.Z, {
    "aria-label": "update queue",
    className: classes.forwardBtn,
    onClick: onUpdate,
    disabled: !value,
    "data-testid": "update-queue-button"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex"
  }, updating ? /* @__PURE__ */ react.createElement(CircularProgress/* default */.Z, {
    size: 21,
    className: classes.progressCircle
  }) : /* @__PURE__ */ react.createElement(ArrowForward/* default */.Z, null)));
};
const REMOVE_OPTION = {
  label: (0,lib/* defineMessage */.Em)({
    id: "queue-dropdown.option.remove-from-queue",
    defaultMessage: "Remove from queue"
  }),
  value: "remove_from_queue"
};
const QueueDropdown = ({ patientId }) => {
  var _a, _b;
  const classes = useStyles();
  const { locationHistory } = (0,LocationHistoryProvider/* useLocationHistoryContext */.JZ)();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [value, setValue] = react.useState("");
  const [shouldNavigateHome, setShouldNavigateHome] = react.useState(false);
  const patientUuid = patientId != null ? patientId : (_a = (0,PatientProvider/* usePatientContext */.p)()) == null ? void 0 : _a.uuid;
  const { data, loading, error } = useQueueDropdownQuery(patientUuid);
  const queueForPatientId = (_b = data == null ? void 0 : data.queueForPatient) == null ? void 0 : _b._id;
  const [
    addPatientToQueue,
    addMutationResult,
    addQueuePatientResult,
    moveQueuePatientResult
  ] = useAddPatientToQueue(patientUuid, queueForPatientId);
  const [removePatientFromQueue, removeMutationResult] = useRemovePatientFromQueue(patientUuid);
  if (!patientUuid) {
    throw new Error(
      "Looks like you are rendering the queue dropdown without any patient uuid in the patient context. This will result in a no render from the dropdown"
    );
  }
  const options = react.useMemo(() => {
    var _a2;
    const queues = (_a2 = data == null ? void 0 : data.facilityQueues) != null ? _a2 : [];
    if (!queues.length) {
      return [];
    }
    const queueOptions = queues.map((queue) => ({ label: queue.name, value: queue._id })).sort((a, b) => {
      const nameA = a.label.toUpperCase();
      const nameB = b.label.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    if (queueForPatientId) {
      queueOptions.push({
        ...REMOVE_OPTION,
        label: formatMessage(REMOVE_OPTION.label)
      });
    }
    return queueOptions;
  }, [queueForPatientId, data, formatMessage]);
  const dropdownUnavailable = !!error;
  const actionAreaProps = {
    dropdownUnavailable,
    loading,
    updating: addMutationResult.loading || removeMutationResult.loading,
    updated: !!(addQueuePatientResult.data || moveQueuePatientResult.data),
    onUpdate: async () => {
      if (value === REMOVE_OPTION.value) {
        await removePatientFromQueue();
      } else {
        await addPatientToQueue(value);
      }
      setValue("");
    },
    value
  };
  if (addMutationResult.data || addQueuePatientResult.data || removeMutationResult.data) {
    const timeout = setTimeout(() => {
      clearTimeout(timeout);
      setShouldNavigateHome(true);
    }, 1e3);
  }
  if (shouldNavigateHome) {
    const indexToRedirect = (0,links/* mostRecentClinicianActionLocationIndex */.xG)(locationHistory);
    if (indexToRedirect && indexToRedirect >= 0) {
      return /* @__PURE__ */ react.createElement(dist/* Navigate */.Fg, {
        to: {
          pathname: locationHistory[indexToRedirect].pathname,
          search: locationHistory[indexToRedirect].search
        },
        state: locationHistory[indexToRedirect].state
      });
    }
    return /* @__PURE__ */ react.createElement(NavigateHome/* default */.Z, null);
  }
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    className: classes.container,
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(dist_module/* SelectField */.mg, {
    fullWidth: true,
    hideHelper: true,
    disabled: dropdownUnavailable || loading,
    label: loading ? formatMessage({
      id: "patientQueueing.dropdown.loading",
      defaultMessage: "Loading..."
    }) : formatMessage({
      id: "patientQueueing.dropdown.queues",
      defaultMessage: "Next queue"
    }),
    name: "patient-queue",
    selectProps: {
      value,
      onChange: (event) => {
        const selectedId = event.target.value;
        if (selectedId === queueForPatientId) {
          return;
        }
        setValue(selectedId);
      },
      classes: {
        icon: classes.selectIcon
      },
      className: classnames_default()(classes.selectFieldInput, {
        [classes.disabled]: dropdownUnavailable || loading
      })
    }
  }, options.map((opt) => {
    const isRemoveOption = opt.value === REMOVE_OPTION.value;
    const isCurrentQueue = opt.value === queueForPatientId;
    return /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
      key: opt.value,
      value: opt.value,
      className: classnames_default()(classes.option, {
        [classes.removeOption]: isRemoveOption,
        [classes.currentQueueOption]: isCurrentQueue
      })
    }, opt.label, isCurrentQueue ? /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
      style: { fontSize: "11px" },
      className: classes.currentQueueOption
    }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "queue-dropdown.option.current-queue",
      defaultMessage: "Current queue"
    })) : null);
  })), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    className: classes.actionContainer
  }, /* @__PURE__ */ react.createElement(ActionArea, {
    ...actionAreaProps
  })));
};
/* harmony default export */ const patient_queue_QueueDropdown = (QueueDropdown);


/***/ })

}]);